import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	threadTypeLabel: {
		id: 'dynamic-cards-search-page.search-result.thread-type-label',
		defaultMessage: 'Thread',
		description: 'Message metadata label',
	},
	messageTypeLabel: {
		id: 'dynamic-cards-search-page.search-result.message-type-label',
		defaultMessage: 'Message',
		description: 'Message metadata label',
	},
	lastActive: {
		id: 'dynamic-cards-search-page.search-result.message-last-active',
		defaultMessage: 'Last active {formattedDate}',
		description: 'Message metadata label',
	},
	attachedDateLabel: {
		id: 'dynamic-cards-search-page.search-result.attachments.attached-date.label',
		defaultMessage: 'Attached {formattedDate}',
		description: 'Attachments showin the date the attachment was added',
	},
	privateChannelLabel: {
		id: 'dynamic-cards-search-page.search-result.private-channel-label',
		defaultMessage: 'Private Channel',
		description: 'Private channel metadata label',
	},
});
